var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 11,
    viewBox: "0 0 5 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67237 6.14078L4.93151 4.16505H3.3105V2.8835C3.3105 2.34284 3.53653 1.81553 4.26256 1.81553H5V0.133495C5 0.133495 4.33105 0 3.69178 0C2.35616 0 1.48402 0.946481 1.48402 2.65922V4.16505H0V6.14078H1.48402V10.9172C1.78196 10.972 2.08676 11 2.39726 11C2.70776 11 3.01256 10.972 3.3105 10.9172V6.14078H4.67237Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.1b0efdae1c93f648d0264105c76a7370.svg";
export { ForwardRef as ReactComponent };